import styled from 'styled-components';

export const Base = styled.div`
	position: fixed;
	z-index: 9000;
	display: flex;
	align-items: center;
	gap: 10px;
	max-width: 320px;
	width: max-content;
	padding: 8px 12px;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
	pointer-events: none;
`;

export const Avatar = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	font-weight: 600;
	color: #ffffff;
`;

export const Info = styled.div`
	min-width: 0;
`;

export const Name = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	font-weight: 600;
	white-space: nowrap;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const You = styled.span`
	font-size: 9px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.4px;
	padding: 1px 5px;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.orange[100]};
	color: ${({ theme }) => theme.orange[700]};
`;

export const Email = styled.div`
	font-size: 11px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${({ theme }) => theme.gray[600]};
`;
